module.exports = __webpack_public_path__ + "02_bob_beige.c46f0d2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_bob_beige.png
// module id = GPyk
// module chunks = 0